<template>
  <div v-if="test">
    <div class="page-title">{{test.subject}}</div>
    <div v-if="test.type == 'NCS'" class="bolder">{{test.name}} / {{test.code}}</div>
    <div class="clearfix my-4">
      <div class="float-left">
        <date-picker2 label="평가일" v-model="test.testDate"/>
      </div>
      <div class="float-right">
        <back-btn-sm class="mr-1">돌아가기</back-btn-sm>
        <save-btn-sm class="mr-1" @click="onSave">저장</save-btn-sm>
        <delete-btn-sm class="mr-1" @click="onDelete">삭제</delete-btn-sm>
      </div>
    </div>
    <div v-for="t in test.test"  :key="t._id" class="mb-5">
      <div class="bolder">
        <mdb-badge color="primary" v-if="test.type =='NCS'">능력단위</mdb-badge>
        <mdb-badge color="primary" >단원명</mdb-badge>
        {{t.unitName}}
      </div>
      <div v-for="(q, ix) in t.questions" :key="q._id" class="ml-4">
        <question-edit :question="q">
          <mdb-badge class="">문제 {{ix+1}}</mdb-badge>
          <mdb-btn color="danger" class="p-0" icon="times" @click="onDeleteQuestion(t.questions, ix)"/>
        </question-edit>
      </div>
      <add-btn-sm class="ml-4" @click="t.questions.push({})">문항 추가</add-btn-sm>
    </div>
  </div>
</template>
<script>
import { mdbTabs } from 'mdbvue'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import Training from '@/models/Training'
import QuestionEdit from '../../../../../components/test/QuestionEdit.vue'
export default {
  name: 'StaffOpenTrainingWritingTestEdit',
  components: { QuestionEdit },
  data () {
    return {
      TAG: 'StaffOpenTrainingWritingTestEdit >>',
      test: undefined
    }
  },
  computed: {
  },
  methods: {
    // subjects와 문제지 맵 로드
    async load () {
      const _id = this.$route.query._id
      this.test = await this.$WritingTest.get(_id)
    },
    async onSave () {
      if (!this.test.testDate) {
        alert('평가일을 지정하세요.')
        return
      }
      if (!confirm('저장할까요?')) return
      // 배점 계산
      let count = 0
      this.test.test.forEach(t => { count += t.questions.length })
      const score = parseFloat((100 / count).toFixed(2))
      this.test.test = this.test.test.map(t => {
        t.questions.forEach(q => (q.assignScore = score))
        return t
      })

      await this.test.save()
    },
    async onDelete () {
      if (!confirm('삭제할까요?')) return
      await this.test.delete()
      this.$router.back()
    },
    onDeleteQuestion (questions, ix) {
      if (!confirm('문항을 삭제할까요?')) return
      questions.splice(ix, 1)
    }
  },
  created () {
    this.load()
  }
}
</script>
